import React, { useEffect, useRef } from 'react';
import { Animated, Pressable, ViewStyle } from 'react-native';
import { styles } from './styles';
import colors from '@/config/colors';

type toggleProps = {
  value: boolean;
  onToggle: (value: boolean) => void;
  style?: ViewStyle;
  disabled?: boolean;
};

export const Toggle: React.FC<toggleProps> = ({
  value,
  onToggle,
  style,
  disabled = false,
}) => {
  const isActive = value;

  const animatedValue = useRef(new Animated.Value(isActive ? 1 : 0)).current;
  const animationConfig = {
    duration: 200,
    useNativeDriver: false,
  };

  useEffect(() => {
    Animated.timing(animatedValue, {
      toValue: isActive ? 1 : 0,
      ...animationConfig,
    }).start();
  }, [isActive]);

  const toggle = () => {
    onToggle(!isActive);
  };

  const interpolatePosition = animatedValue.interpolate({
    inputRange: [0, 1],
    outputRange: [3, 25],
  });

  const backgroundColor = animatedValue.interpolate({
    inputRange: [0, 1],
    outputRange: [
      colors.newUI.therapist.grey30, // OFF state background
      colors.newUI.therapist.green70, // ON state background
    ],
  });

  const knobColor = isActive ? colors.white : colors.newUI.therapist.grey70;

  return (
    <Pressable
      onPress={toggle}
      disabled={disabled}
      accessibilityRole="switch"
      accessibilityState={{ checked: isActive, disabled }}
      style={[style, disabled && { opacity: 0.5 }]}
    >
      <Animated.View style={[styles.toggle, { backgroundColor }]}>
        <Animated.View
          style={[
            styles.circle,
            {
              transform: [{ translateX: interpolatePosition }],
              backgroundColor: knobColor,
            },
          ]}
        />
      </Animated.View>
    </Pressable>
  );
};
